import clx from 'classnames';
import React from 'react';

import { down } from 'styled-breakpoints';
import styled from 'styled-components';

interface StyledProps {
  padding?: number;
  justifyContent?: string;
}

const StyledButtonRowCard = styled.div<StyledProps>`
  display: flex;
  position: relative;
  display: block;
  padding: ${props => props.padding ?? 24}px;
  &:not(.no-divider) {
    border-top: 1px solid ${props => props.theme.colorSplit};
    padding-top: 24px;
    margin-top: 24px;
    margin-bottom: 0;
    ${down('sm')} {
      padding-top: 12px;
      margin-top: 12px;
    }
    &.down-divider {
      border-bottom: 1px solid ${props => props.theme.colorSplit};
      padding-bottom: 24px;
      margin-bottom: 24px;
      ${down('sm')} {
        padding-bottom: 12px;
        margin-bottom: 12px;
      }
    }
  }
  margin: -24px;
  margin-top: 24px;
  ${down('sm')} {
    margin: -12px;
    margin-top: 12px;
  }
`;
const ButtonRowCardContent = styled.div`
  /* border-top: 1px solid ${props => props.theme.colorSplit}; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* padding-top: 24px; */
`;

export interface ButtonRowCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /* Per rimuovere il bordo superiore (e inferiore se position === 'middle')
    (per compatibilità con versione affixed: <ButtonRowCardFooter />) */
  removeDivider?: boolean;
  /* padding per il contenuto (pulsanti) */
  padding?: number;
  /* allineamento contenuto */
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between';
  /* posizione nella card dell'elemento: 
  Middle include bordo superiore ed inferiore, Footer solo superiore */
  position?: 'middle' | 'footer';
}

/**
 * Container per i pulsanti Salva etc posizionati nella della Card
 *
 * È possibile specificare un padding per il contenuto (pulsanti)
 */
export function ButtonRowCard(props: ButtonRowCardProps) {
  const {
    children,
    className,
    removeDivider,
    position = 'footer',
    ...otherProps
  } = props;
  return (
    <StyledButtonRowCard
      {...otherProps}
      className={clx(className, {
        'no-divider': removeDivider,
        'down-divider': position === 'middle',
      })}
    >
      <ButtonRowCardContent>{children}</ButtonRowCardContent>
    </StyledButtonRowCard>
  );
}
